module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/about-6908b5ef7598deac70b59be4362f84a6.jpg";